import PropTypes from 'prop-types';

import summaryShape from 'Workspace/types/pluginSummary';
import manifestShape from 'Workspace/types/pluginManifest';
import { collaboratorSummaryShape } from 'Workspace/types/collaborator';

const pluginDetailsShape = PropTypes.shape({
  manifest: manifestShape,
  summary: summaryShape,
  collaborators: collaboratorSummaryShape,
});

export default pluginDetailsShape;
